/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DiscountCategoryResponse } from './DiscountCategoryResponse';
export type DiscountResponse = {
    validUntil: string | null;
    id: number;
    therapistId: number;
    clientId: number;
    categoryId: number;
    discountType: DiscountResponse.discountType;
    value: string;
    isActive: boolean;
    note: string | null;
    createdAt: string;
    category: DiscountCategoryResponse | null;
};
export namespace DiscountResponse {
    export enum discountType {
        PERCENTAGE = 'percentage',
        FIXED = 'fixed',
    }
}

